<template>
  <v-card class="elevation-0 transparent">
    <v-card-title
      primary-title 
      class="layout justify-center"
    >
      <div class="h_second_line">
        {{ $t('h_about_head_04') }}
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-list two-line class="elevation-0 transparent">
      <template v-for="(item, index) in certMap">
        <v-list-item :key="item.subtitle" @click="handleClick(item.link)">
          <template v-slot:default="{ active, toggle }">
            <v-list-item-content>
              <v-list-item-title class="crtext" v-text="item.title"></v-list-item-title>
              <v-list-item-subtitle class="text--primary" v-html="item.subtitle"></v-list-item-subtitle>
              <v-list-item-subtitle v-text="item.headline"></v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
        <v-divider
          v-if="index + 1 < item.title"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  export default {
    computed:{
      certMap(){
        return this.$store.getters.getCM
      }
    },
    methods: {
      handleClick: function(target) {
        this.$router.resolve({query: {data: "Certificate"}});
        window.open(target, '_blank');
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>